import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

// Services
import { RouteParam, ServiceBase } from '../service-base';

// Modèles
import { AccountingPeriod } from 'src/app/@shared/models/accounting/accounting-period.model';

const CLASS_NAME = 'AccountingPeriod';
const ENDPOINT = `/accounting-periods/`;
const ROUTES: RouteParam[] = [
    { key: 'close', path: '{id}/close/' },
    { key: 'reopen', path: '{id}/reopen/' },
];

@Injectable({
    providedIn: 'root'
})
export class AccountingPeriodService extends ServiceBase {

    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addRoutes(ROUTES);
    }

    public close$(id: number): Observable<AccountingPeriod> {
        const url = this.routes['close'].replace('{id}', id.toString());
        return this._postAction$<AccountingPeriod>(url).pipe(
            tap(instance => this._updated$.next(instance))
        );
    }

    public reopen$(id: number): Observable<AccountingPeriod> {
        const url = this.routes['reopen'].replace('{id}', id.toString());
        return this._postAction$<AccountingPeriod>(url).pipe(
            tap(instance => this._updated$.next(instance))
        );
    }
}
